import { WebSettingsAction } from './actions'
import { UserPermissions, WebSettings } from './types'

export interface State {
  settings: WebSettings
  userPermissions: UserPermissions
}

export const getInitialState = () => {
  const initialState: State = {
    settings: {
      isLoading: true,
      enableLTHedge: false,
      icebergThreshold: 500,
      maxGrids: 5,
      showLT: false,
      showTsy: false,
      showTOB: false,
      showCheckout: false,
      exposureDurationValues: [30, 60, 120],
      exposureDurationDefault: 60,
      enableRFQ: false,
      listTradingMaxRows: 200
    },
    userPermissions: {
      isAdmin: false,
      isBroker: false,
      hasTradingRights: false,
      canEditTiers: false,
      canSeeSystemParamEditor: false,
      canMarkRestricted: false,
      canForceCancel: false,
      canEnterPassiveOrders: false
    }
  }
  return initialState
}

export default (
  state = getInitialState(),
  action: WebSettingsAction
): State => {
  switch (action.type) {
    case 'webSettings.setWebSettings':
      return {
        ...state,
        settings: action.payload.settings
      }
    case 'webSettings.fetchUserPermissions':
      return { ...state }
    case 'webSettings.fetchUserPermissionsSuccess':
      return {
        ...state,
        userPermissions: action.payload
      }
    default:
      return state
  }
}
